import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { switchProp, ifProp } from "styled-tools";

const BaseStyle = styled.a.attrs(
	({
		left,
		right,
		nomargin,
		margin,
		href,
		fontsize,
		fontWeight,
		marginsmall,
		white,
		color,
		theme,
		alignItems,
		display,
		justifyContent,
		width,
	}) => ({
		marginright: left ? "auto" : 0,
		width: width ? width : "",

		marginleft: right ? "auto" : 0,
		margin: nomargin
			? 0
			: margin
			? margin
			: `0.5rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
		href: href ? href : "",
		fontsize: fontsize ? fontsize : "16px",
		justifyContent: justifyContent ? justifyContent : "",
		display: display ? display : "",

		alignItems: alignItems ? alignItems : "",

		marginSmall: marginsmall ? marginsmall : margin ? margin : 0,
		color: color ? color : white ? white : theme.colors.primary,
	})
)`
	display: ${({ display }) => display};
	align-items: ${({ alignItems }) => alignItems};
	font-size: ${({ fontSize }) => fontSize};
	font-weight: ${({ fontWeight }) => fontWeight};
	margin: ${({ marginSmall }) => marginSmall};
	width: ${({ width }) => width};
	${media.greaterThan(breakpoints.mobile)`
	justify-content: ${({ justifyContent }) => justifyContent};
	
	
	`}
	${media.greaterThan(breakpoints.ipad)`
		margin-right: ${({ marginright }) => marginright};
		margin-left: ${({ marginleft }) => marginleft};
		margin: ${({ margin }) => margin};
  	`}

	&:focus,
  	&:hover {
		span {
			border-bottom: ${({ inverted, color, theme }) =>
				inverted ? `2px solid ${theme.colors.none}` : `2px solid ${color}`};
		}
	}

	span {
		border-bottom: ${({ inverted, color, theme }) =>
			inverted ? `2px solid ${color}` : `2px solid ${theme.colors.none}`};
		transition: all 0.2s ease;
		color: ${({ color }) => color};
	}
`;

export const PrimaryLinkStyle = styled(BaseStyle)``;

export const HeaderLinkStyle = styled(BaseStyle).attrs(({ size }) => ({
	elementsize: size,
}))`
	display: ${({ inline }) => (inline ? "inline-block" : "block")};
	font-weight: bold;
	font-size: ${({ fontSize }) => (fontSize ? fontSize : "")};
	color: ${({ color }) => (color ? color : "")};
	${switchProp("elementsize", {
		h1: css`
			font-size: 36px;
			line-height: 42px;

			${media.greaterThan(breakpoints.ipad)`
            font-size: 50px;
            line-height: 38px;
        `}
		`,
		h2: css`
			font-size: 24px;
			line-height: 30px;

			${media.greaterThan(breakpoints.ipad)`
            font-size: 32px;
            line-height: 38px;
        `}
		`,
		h3: css`
			font-size: 20px;
			line-height: 26px;

			${media.greaterThan(breakpoints.ipad)`
            font-size: 24px;
            line-height: 30px;
        `}
		`,
		h4: css`
			font-size: 18px;
			line-height: 24px;

			${media.greaterThan(breakpoints.ipad)`
            font-size: 20px;
            line-height: 24px;
        `}
		`,
	})};
`;
